export const SET_TASK_QUERY_PARAM = 'SET_TASK_QUERY_PARAM';
export const SET_TASK_MODAL_DATA = 'SET_TASK_MODAL_DATA';

export const setTaskModal = payload => dispatch => {
  dispatch({ type: SET_TASK_MODAL_DATA, payload });
};
